import React, { useContext } from 'react';

import { DataContext } from '../../context/DataContext';
import { tipoDocumentos } from '../../data/mochaData';
import { tipoId } from '../../utils/constanst';
import { getDateFronIdentity } from '../../utils/helpers';

import DateControl from '../controls/DateControl';

import DivRow from '../controls/DivRow';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';
import InputFile from '../controls/InputFile';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';

const Step1 = () => {

    const { poliza, setPoliza, changeHandler } = useContext(DataContext);

    const onChangeDoc = e =>{

        const nace = getDateFronIdentity(e.target.value);
        setPoliza({...poliza, identificacion: e.target.value, fechaNacimiento: nace});
    }

    const onChangeFiles = (id, newFile) =>{

        const { file } = poliza;

        if (id === "file0")
            file[0] = newFile
        
        if (id === "file1")
            file[1] = newFile

        setPoliza({...poliza, file});	

    }

    const onChangeMunicipio = e =>{
        setPoliza({...poliza, departamento: e.target.value, municipio: ''});
    }

    const { file } = poliza;

    return (
        <div className="reponsive">
            <div className="reponsive-width-6">   
            <div className='box-pl2-pr2'>
                <InputFile id="file0" label='Documento de identificación frontal' handlerFiles={onChangeFiles} file={file[0]} part='frontal' />
                <InputFile id="file1" label='Documento de identificación trasera' handlerFiles={onChangeFiles} file={file[1]} part='trasera'/>
                <Input label='Nombres' field='nombres' value={poliza.nombres} onChange={changeHandler} />
                <Input label='Apellidos' field='apellidos' value={poliza.apellidos} onChange={changeHandler} />
                
                {   poliza.tipoId === tipoId.cedula &&

                    <DropDownInput label='Documentación' dataProvider={tipoDocumentos} 
                        value={poliza.identificacion} onChange={onChangeDoc}
                        valueSelect={poliza.tipoId} onChangeSelect={changeHandler}
                        field='identificacion' 
                        fieldSelect='tipoId'     
                        mask= "999-999999-9999a"
                        pattern= "\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w"
                        title="Documento invalido"
                    />
                }

                {   poliza.tipoId !== tipoId.cedula &&

                    <DropDownInput label='Documentación' dataProvider={tipoDocumentos} 
                        value={poliza.identificacion} onChange={onChangeDoc}
                        valueSelect={poliza.tipoId} onChangeSelect={changeHandler}
                        field='identificacion' 
                        fieldSelect='tipoId'                            
                        title="Documento invalido"
                    />
                }


                <InputSelect field='nacionalidad' label='Nacionalidad' value={poliza.nacionalidad} onChange={changeHandler}  dataProvider='nacionalidad' />
                <InputSelect field='sexo' label='Sexo'  value={poliza.sexo} onChange={changeHandler} dataProvider='sexo' />
                <Input label='Dirección' field='direccion' value={poliza.direccion} onChange={changeHandler}/>
                <DateControl label='Fecha de nacimiento' value={poliza.fechaNacimiento} onChange={date => setPoliza({ ...poliza, fechaNacimiento: date})}/>
                <InputSelect label='Estado Civil' field='estadoCivil' value={poliza.estadoCivil} onChange={changeHandler} dataProvider='estadocivil' />
            </div>
            </div>
            <div className="reponsive-width-6">  
                <div className='box-pl2-pr2'>
                <InputSelect label='País' value={poliza.pais} field='pais' dataProvider='paises' onChange={changeHandler}/>
                <InputSelect label='Departamento' containBlank={true} value={poliza.departamento} field='departamento' dataProvider={`paises/${poliza.pais}/departamentos`} onChange={onChangeMunicipio}/>
                <InputSelect label='Municipio' containBlank={true} value={poliza.municipio} field='municipio' dataProvider={`paises/${poliza.pais}/departamentos/${poliza.departamento}/ciudades`} onChange={changeHandler}/>
                <div className="group-controls">
                    <Input label='Telefono Casa' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999' field='telefonoCasa' placeholder='0000-0000' value={poliza.telefonoCasa} onChange={changeHandler} classNameContainer='w45' classNameInput='w100' />
                    <Input label='Telefono Celular' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999' field='telefonoCelular' placeholder='0000-0000' value={poliza.telefonoCelular} onChange={changeHandler}  classNameContainer='w45' classNameInput='w100'/>                
                </div>                
                <DateControl label='Fecha vigencia documento' value={poliza.fechaVigencia} onChange={date => setPoliza({ ...poliza, fechaVigencia: date})}/>
                <Input label='Correo electronico' type='email' field='email' value={poliza.email} onChange={changeHandler} />
                <InputSelect label='Profesión' containBlank={true} value={poliza.profesion} field='profesion' dataProvider='profesion' onChange={changeHandler}/>
                <SwitchButton label="Posee casa propia" value={poliza.hasHouse} onClick={value => setPoliza({ ...poliza, hasHouse: value })} />
                <SwitchButton label="Posee vehiculo propio" value={poliza.hasCar} onClick={value => setPoliza({ ...poliza, hasCar: value })} />
                <SwitchButton label="Tiene hijos" value={poliza.hasChildren} onClick={value => setPoliza({ ...poliza, hasChildren: value })} />
            </div>
            </div>
        </div>
    );
}

export default Step1;
